module.exports = __webpack_public_path__ + "static/media/img_girl_writing_side.a7020099.png";